'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var eq = exports.eq = function eq(l, r) {
  return l === r;
};

var isSomething = exports.isSomething = function isSomething(value) {
  return value != null;
};

var Option = exports.Option = function () {
  function Option(val) {
    _classCallCheck(this, Option);

    this.val = val;
  }

  _createClass(Option, [{
    key: 'isSome',
    value: function isSome() {
      return isSomething(this.val);
    }
  }, {
    key: 'isNone',
    value: function isNone() {
      return !isSomething(this.val);
    }
  }, {
    key: 'unwrap',
    value: function unwrap() {
      if (this.val) {
        return this.val;
      }
      throw new Error('no value');
    }
  }, {
    key: 'unwrapOr',
    value: function unwrapOr(def) {
      if (this.val) {
        return this.val;
      }
      return def;
    }
  }, {
    key: 'map',
    value: function map(f) {
      /* spell it out because Flow can't use isSomething as a disambiguation */
      return this.val != null ? new Option(f(this.val)) : new Option();
    }
  }, {
    key: 'equals',
    value: function equals(eq_, rside) {
      /* spell it out because Flow can't use isSomething as a disambiguation */
      if (this.val == null && rside.val == null) {
        return true;
      }
      if (this.val && rside.val) {
        return eq_(this.val, rside.val);
      }
      return false;
    }
  }]);

  return Option;
}();


//////////////////
// WEBPACK FOOTER
// ./node_modules/luminescent-dreams-base/lib/Option.js
// module id = 236
// module chunks = 0